<template>
  <tr>
    <td colspan="2" class="name-heading" @click.stop.prevent="goToEdit">
      <!-- Star -->
      <template>
        <!-- Loader -->
        <div
          class="loader-container-small"
          v-if="
            personOrOtherEvent + id in sendingFavRequest &&
              sendingFavRequest[personOrOtherEvent + id] === true
          "
        >
          <div class="loader-small"></div>
        </div>

        <!-- Empty star -->
        <img
          class="img-star"
          :src="emptyStarIcon"
          v-else-if="favouriteId === 0"
          @click.stop.prevent="sendAddFavouritesRequestLocal"
        />

        <!-- Filled star -->
        <img
          class="img-star"
          :src="filledStarIcon"
          v-else
          @click.stop.prevent="sendRemoveFavouritesRequestLocal"
        />
      </template>

      <a
        v-html="name"
        class="patient-name"
        :class="
          personOrOtherEvent !== 'other_event' && by !== 'CLIENTS'
            ? 'grey--text'
            : null
        "
        :href="name+12"
      >{{name}}
      </a>
      <div
        class="contacts-ec-cta"
        v-if="personOrOtherEvent === 'group_appointment'"
      >
        <a
          @click="goToChat"
          class="buttonstyle btn-group-chat"
          v-if="showGroupChat"
        >
          Group Chat
        </a>
        <button
          v-if="personOrOtherEvent === 'group_appointment'"
          @click.stop="composeEmail(id, true)"
          :class="{buttonstyle: true, disabled: isAllParticipantsPortalUser}"
        >
          Group Email
        </button>
      </div>
      <button
        v-if="
          (personOrOtherEvent === 'app_user' || personOrOtherEvent === 'subscriber') ||
          (fileteredEmails.length > 0 && personOrOtherEvent != 'group_appointment')
        "
        @click.stop="composeEmail(id)"
        class="buttonstyle btn-email">
        Email
      </button>
      <button
        v-if="
          fileteredEmails.length == 0 &&
          personOrOtherEvent != 'group_appointment' &&
          personOrOtherEvent != 'app_user' &&
          personOrOtherEvent != 'subscriber'
        "
        class="buttonstyle disabled"
        @click.stop="toggleAddEmailOnlyDiv">
        Email
      </button>
    </td>

    <!-- Show add phone -->
    <td
      key="1"
      class="no-phone"
      v-show="(showPhone && fileteredPhones.length === 0) || addPhoneUser"
    >
      <transition name="expand" appear mode="out-in">
        <p class="content-no-mail" v-if="showNotPortalMessage">
          This contact cannot chat because they are not a member of your portal.
        </p>
      </transition>
      <!-- <span>Phone</span> -->
      <div key="2" class="no-phone-div no-phone-client-div">

        <template v-if="addPhoneUser">
          <!-- ios input -->
          <input
            v-if="iOS"
            v-model="phone"
            @keydown="setPhone"
            @blur="addPhoneLocalClientAction"
            type="text"
            pattern="[0-9]*"
            placeholder="Add phone"
            class="add-phone"
            ref="phone"
            autocomplete="off"
            maxlength="12"
          />
          <!-- android input -->
          <input
            v-else
            v-model="phone"
            @keypress.enter="addPhoneLocalClientAction"
            @keydown="setPhone"
            @blur="hideAddPhoneUser"
            type="text"
            inputmode="numeric"
            placeholder="Add phone"
            class="add-phone"
            ref="phone"
            autocomplete="off"
            maxlength="12"
          />
          <a
            v-if="phone !== ''"
            @click.prevent="hideAddPhoneUser"
            data-v-6b6a9972
            href="#"
            class="search-close-icon"
          >
            <object
              data-v-6b6a9972
              :data="cancelSvg"
              type="image/svg+xml"
            ></object>
          </a>
        </template>

        <!-- All buttons -->
        <template v-else>
          <a
            @click="goToChat"
            class="buttonstyle"
            v-if="userID !== null && userID !== 0 && userID !== undefined"
          >
            Chat
          </a>
          <a
            href="#"
            class="buttonstyle disabled"
            @click.prevent="showTheNotPortalMessage"
            v-else
          >
            Chat
          </a>
          <a
            href="#"
            class="buttonstyle disabled"
            @click.prevent="focusPhoneInput"
          >
            <template v-if="!addPhoneServerReq"> Call </template>
            <div class="loader-container-small" v-if="addPhoneServerReq">
              <div class="loader-small"></div>
            </div>
          </a>
        </template>
      </div>
    </td>

    <!-- There is phone already -->
    <td key="2" v-show="fileteredPhones.length !== 0 && !addPhoneUser">
      <transition name="expand" appear mode="out-in">
        <p class="content-no-mail" v-if="showNotPortalMessage">
          This contact cannot chat because they are not a member of your portal.
        </p>
      </transition>
      <!-- <span>Phone</span> -->
      <!--changing dropdown design-->
      <div class="phone-dropdown-design mr-0 float-none">
        <select
          class="custom-select"
          @change="changedPhone"
          :value="selectedIndex"
        >
          <option
            v-for="(phone, index) in fileteredPhones"
            :key="index"
            :value="index"
            >{{ phone }}</option
          >
        </select>
      </div>
      <img
        ref="plusIcon"
        class="img-plus"
        :src="plusIcon"
        v-if="fileteredPhones.length < 4 && showPhone"
      />

      <!-- All buttons -->
      <a
        @click="goToChat"
        class="buttonstyle"
        v-if="userID !== null && userID !== 0 && userID !== undefined"
        >Chat</a
      >
      <a
        href="#"
        class="buttonstyle disabled"
        @click.prevent="showTheNotPortalMessage"
        v-else
        >Chat</a
      >
      <a
        v-if="fileteredPhones.length !== 0"
        :href="`tel:${fileteredPhones[selectedIndex]}`"
        class="buttonstyle"
        >Call</a
      >
    </td>

    <!-- No phone but add phone is not allowed -->
    <td
      key="3"
      v-if="
        !showPhone &&
          fileteredPhones.length === 0 &&
          personOrOtherEvent !== 'group_appointment'
      "
    >
      <!-- <div class="phone-dropdown-design mr-0 float-none">
        <select class="custom-select">
          <option value="0" disabled selected>No contacts</option>
        </select>
      </div> -->
      <div class="phone-dropdown-design mr-0 float-none alertbox">
        <i class="text-disabled">
          Phones for {{ userType == "app_user" ? "Users" : "Subscribers" }} must
          be added in the regular PSYBooks app.
        </i>
      </div>
      <!-- All buttons -->
      <a
        @click="goToChat"
        class="buttonstyle"
        v-if="userID !== null && userID !== 0 && userID !== undefined"
        >Chat</a
      >
      <a
        href="#"
        class="buttonstyle disabled"
        @click.prevent="showTheNotPortalMessage"
        v-else
        >Chat</a
      >
      <a href="#" class="buttonstyle disabled" @click.prevent>Call</a>
    </td>
    <div class="profile-email-info" v-if="fileteredEmails.length==0 && showAddEmailOnlyDiv && personOrOtherEvent !== 'group_appointment'">
      <p>
        This person does not have an email address on file. You can add one below:
      </p>
      <div class="enter-email">
        <input type="email" v-model="emailaddresstoadd">
        <span class="icon-remove" @click="removeAddress"><img src="../../assets/img/icon-close.png" alt="Remove"/></span>
      </div>
      <button class="buttonstyle" @click="addEmailOnly()">Add</button>
    </div>

    <!-- If there is a group inner -->
    <group-inner
      v-if="innerUsers"
      :id="id"
      :inner-users="innerUsers"
      :show-inner="showInner"
      :update-show-inner="updateShowInner"
    />
  </tr>
</template>

<script>
import GroupInner from "./Contacts/GroupInner";
import { addPhoneMixin } from "../../mixins/addPhoneMixin";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "ClinetAction",
  mixins: [addPhoneMixin],
  props: {
    name: String,
    active: Boolean,
    phones: Array,
    emails: Array,
    userID: Number,
    clientId: [String, Number],
    by: String,
    id: Number,
    favouriteId: Number,
    providerId: Number,
    personOrOtherEvent: String,
    selectedPhone: String,
    innerUsers: Array,
    userType: String,
    typeOfContactClicked: [String, Boolean],
    showAdd: Boolean
  },
  components: {
    GroupInner
  },
  data() {
    return {
      selectedIndex: 0,
      showNotPortalMessage: false,
      showAddEmailOnlyDiv: false,
      emailaddresstoadd: null,
      showInner: {},
      emptyStarIcon: require("../../assets/img/m_favorites-empty.png"),
      filledStarIcon: require("../../assets/img/m_favorites.png"),
      plusIcon: require("../../assets/img/m_plus.png"),
      cancelSvg: require("../../assets/svg/cancel.svg")
    };
  },
  computed: {
    ...mapGetters("favourites", {
      sendingFavRequest: "getSendingFavRequest"
    }),
    ...mapGetters("clients", {
      getClients: "getClients"
    }),
    ...mapGetters({
      getAppointmentType: "getAppointmentType"
    }),
    ...mapGetters({
      userRole: "getUserRole"
    }),
    isAllParticipantsPortalUser() {
      let isAllPortalUsers = true;
      this.innerUsers.forEach(user => {
        if(user && user.user_id > 0) {
          isAllPortalUsers = false;
        }
      });

      return isAllPortalUsers;
    },
    fileteredPhones() {
      return this.phones.filter(phone => {
        return phone !== "" && phone !== null;
      });
    },
    fileteredEmails() {
      return this.emails.filter(email => {
        return email !== "" && email !== null && undefined !== email;
      });
    },
    showPhone() {
      if (this.by === "CLIENTS") {
        return true;
      } else {
        return this.clientId.split(".")[0] === "other_event";
      }
    },
    focus() {
      return this.filteredPhones.length !== 0;
    },
    showGroupChat() {
      let show = true;
      if (this.innerUsers) {
        this.innerUsers.forEach(user => {
          show = show && user.type !== "subscriber" && user.type !== "app_user";
        });
      }

      return (
        this.personOrOtherEvent === "group_appointment" &&
        this.userRole !== 24 &&
        show
      );
    }
  },
  methods: {
    ...mapMutations("chat", {
      setCurrentSelectedNew: "setCurrentSelectedNew" // Set what the current chat is
    }),
    ...mapMutations({
      setLoadingAddAppointment: "setLoadingAddAppointment" // Set what the current chat is
    }),
    ...mapMutations("portalemail", {
      resetStateForOtherUser: "resetStateForOtherUser",
      setSelectedAppUserUserId: "setSelectedUserId",
      setInitialMailDetails: "setInitialMailDetails" // Set initial compose email address
    }),
    ...mapActions("person", {
      editPerson: "editPerson" // Set what the current chat is
    }),
    ...mapActions("portalemail", {
      checkUserContact : "checkUserContact"
    }),
    ...mapActions("clients", {
      getClientDetails: "getClientDetails"
    }),
    ...mapMutations("clients", {
      addClientEmail: "addClientEmail"
    }),
    ...mapActions({
      getFormDetailsPersonOther: "getFormDetailsPersonOther" // Get form details from the server
    }),
    /**
     * Redirect the user to compose email route.
     */
    async composeEmail(id, isGroup) {
      // Check if user is on contact list
      let json = await this.checkUserContact({userId: id, isGroup: isGroup ? 1: 0});

      if(json.error) {
        this.$store.dispatch("globalMessagePopup", json.error);
      } else {
        json.userIds = json.userIds.map(userId => Number(userId));
        if(json.userIds.length > 0) {
          this.resetStateForOtherUser();
          this.setSelectedAppUserUserId(0);
          this.setInitialMailDetails({
            toArray: json.userIds
          });
          this.$router.push("/compose-email");
        } else {
          if(isGroup) {
            this.$store.dispatch("globalMessagePopup", "Not even a single user in this group are Portal User. So, they can not receive emails");
          } else {
            this.$store.dispatch("globalMessagePopup", "This person can't receive email because they're not a Portal User.");
          }
        }
      }
    },
    /**
     * Which inner list to show
     */
    updateShowInner(id, value) {
      this.showInner[id] = value;
    },
    sendAddFavouritesRequestLocal() {
      this.sendAddFavouritesRequest({
        id: this.id,
        type: this.personOrOtherEvent,
        provider: this.providerId
      });
    },
    sendRemoveFavouritesRequestLocal() {
      this.sendRemoveFavouritesRequest({
        favourite_id: this.favouriteId,
        id: this.id,
        type: this.personOrOtherEvent,
        provider: this.providerId
      });
    },
    sendAddSelectedPhoneRequestLocal() {
      this.addSelectedPhone({
        id: this.id,
        type: this.personOrOtherEvent,
        provider: this.providerId,
        phone: this.fileteredPhones[this.selectedIndex]
      });
    },
    changedPhone(event) {
      this.selectedIndex = event.target.value;
      this.sendAddSelectedPhoneRequestLocal();
    },
    toggleAddEmailOnlyDiv(){
      // this.$parent.$refs.eachAction.showAddEmailOnlyDiv = true;
      this.$parent.$refs.eachAction.forEach(el=>{
        el.showAddEmailOnlyDiv = false
      })
      this.showAddEmailOnlyDiv = true;
    },
    removeAddress(){
      this.emailaddresstoadd = null
    },
    async addPersonEmail(){
      // alert(this.clientId)
      // alert(this.providerId)
      var json = await this.$store.dispatch(
        "makeAuthRequest",
        {
          url: "clients/emailedit/"+this.id,
          method: "PATCH",
          chat: true,
          data: {
            email: [this.emailaddresstoadd],
            providerID: this.providerId,
            clientId: this.id
          }
        },
        {
          root: true
        }
      );
      if ("error" in json) { // *
        /*if (json.code === 400) {
          this.$store.dispatch(
            "globalMessagePopup",
            ERROR_MESSSAGE.emailExist
          );
        } else {
          this.$store.dispatch("globalMessagePopup", ERROR_MESSSAGE[500]);
        }*/
        this.$store.dispatch("globalMessagePopup", json.error);
      } // *
      else{ // *
        this.getFormDetailsPersonOther();
        this.addClientEmail({
          providerId: this.providerId,
          clientId: this.id,
          emailId: this.emailaddresstoadd
        });
      } // *
      // const client_id = this.id;
      // const clientIndex = this.getClients[
      //   this.providerId
      // ].findIndex(client => {
      //   return client.id === client_id;
      // });
      // console.log(client_id)
      // console.log(clientIndex)
      // console.log(this.getClients)
      // this.getClients[this.providerId][clientIndex].email1 = this.emailaddresstoadd;
      // // this.$parent.filteredClientsForContacts()[this.providerId][clientIndex].email1 = this.emailaddresstoadd;
      // this.$parent.filteredClientsForContacts[clientIndex].email[0]=this.emailaddresstoadd
      // console.log(this.$parent.filteredClientsForContacts[clientIndex])
    },
    async addOtherEventEmail(){
      // alert(this.clientId)
      // alert(this.providerId)
      var json =  await this.$store.dispatch(
        "makeAuthRequest",
        {
          url: "others/emailedit/" + this.id,
          method: "PATCH",
          chat: true,
          data: {
            email: [this.emailaddresstoadd],
            providerID: this.providerId
          }
        },
        {
          root: true
        }
      );
      if ("error" in json) {
        /*if (json.code === 400) {
          this.$store.dispatch(
            "globalMessagePopup",
            ERROR_MESSSAGE.emailExist
          );
        } else {
          this.$store.dispatch("globalMessagePopup", ERROR_MESSSAGE[500]);
        }*/
        this.$store.dispatch("globalMessagePopup", json.error);
      }
      else{
        this.getFormDetailsPersonOther();
      }
      // this.getClientDetails();
      // var editPersonId = this.id;
      // const peoples = this.getAppointmentType.people;
      // const personIndex = peoples[this.providerId].findIndex(person => {
      //   return person.id === editPersonId;
      // });
      // peoples[this.providerId][personIndex].email = [this.emailaddresstoadd];
    },
    addEmailOnly(){
      if(this.emailaddresstoadd != null){

        switch (this.personOrOtherEvent) {
          case "person":
            this.addPersonEmail();
          break;

        case "other_event":
          this.addOtherEventEmail();
          break;

        case "group_appointment":
          this.setCurrentSelectedNew(undefined);
          break;

        default:
          this.setCurrentSelectedNew("APP_USER");
          break;
        }
      }
      else{
        this.$store.dispatch(
            "globalMessagePopup","Email address is required"
          );
      }
      //alert(this.emailaddresstoadd)
      //this.emails.push(this.emailaddresstoadd);
      // const selectedProviderId = this.$store.rootGetters.getSelectedProviderID;
    },
    /**
     * Go to the chat of an user
     */
    goToChat() {
      // Step 1: Set the type of the new client
      switch (this.personOrOtherEvent) {
        case "person":
          this.setCurrentSelectedNew("CLIENT_PORTAL_USER");
          break;

        case "other_event":
          this.setCurrentSelectedNew("NON_CLIENT_PORTAL_USER");
          break;

        case "group_appointment":
          this.setCurrentSelectedNew(undefined);
          break;

        default:
          this.setCurrentSelectedNew("APP_USER");
          break;
      }

      // Step 2: Check if group appointment
      if (this.personOrOtherEvent !== "group_appointment") {
        // Step 2.1: Set the selectedted user id
        this.setSelectedUserId(this.userID);

        // Step 2.2: Go to the messages route
        this.$router.push("/messenger");
      } else {
        // Step 2.1: Go to the group messages route
        this.$router.push(`/messenger/group/${this.id}`);
      }
    },
    goToRouter(link){
      this.$router.push(link);
    },
    goToEdit() {
      if (this.by == "CLIENTS") {
        this.$parent.typeOfContactClicked = false;
        this.editClient(+this.clientId.split(".")[1]);
        this.$router.push("/add_client");
      } else if (this.personOrOtherEvent === "group_appointment") {
        this.$parent.typeOfContactClicked = false;
        this.showInner = this.showInner[this.id]
          ? {
              ...this.showInner,
              [this.id]: false
            }
          : {
              ...this.showInner,
              [this.id]: true
            };
      } else if (this.personOrOtherEvent === "other_event") {
        // this.hideaddcontact
        this.$parent.$parent.showAdd = false;
        // this.showAdd=false;
        // this.$store.commit("addNew/clear");
        this.$parent.typeOfContactClicked = this.personOrOtherEvent;
        this.$parent.$parent.$refs.headerBottom.hideSearch();
        this.editPerson(+this.clientId.split(".")[1]);
      } else {
        this.$parent.typeOfContactClicked = false;
      }
    },
    /**
     * Show that the user is not a portal user message
     */
    showTheNotPortalMessage() {
      this.showNotPortalMessage = true;
      setTimeout(() => {
        if (this && this.showNotPortalMessage) {
          this.showNotPortalMessage = false;
        }
      }, 10000);
    },

    /**
     * Focus on phone input
     */
    focusPhoneInput() {
      this.addPhoneUser = true;
      this.$nextTick(() => {
        this.$refs.phone.focus();
      });
    }
  },
  created() {
    for (let i = 0; i < this.fileteredPhones.length; i++) {
      if (this.fileteredPhones[i] === this.selectedPhone) {
        this.selectedIndex = i;
      }
    }
  },
  mounted() {
    if (this.$refs.plusIcon !== undefined) {
      this.$refs.plusIcon.addEventListener("click", () => {
        this.addPhoneUser = true;
        this.$nextTick(() => {
          this.$refs.phone.focus();
        });
      });
    }
  }
};
</script>

<style>
.profile-email-info{
  background-color:gray !important;
  color: white;
  font-size: smaller;
  width:calc(100% - 30px);
  padding: 5px 15px 25px;
  margin-bottom: -6px;
  overflow:hidden;
}
.profile-email-info p{
  margin:10px 0;
  line-height: 24px;
}

.enter-email{
  position:relative;
  margin-bottom:15px;
}
.enter-email input{
  display:block;
  width:calc(100% - 20px);
  padding:6px 10px;
}
.enter-email span.icon-remove{
  width:24px;
  height:24px;
  position:absolute;
  top:4px;
  right:1px;
}
button.buttonstyle{
  border-radius: 5px;
  border:none;
  padding:5px 10px;
}
.enter-email span.icon-remove img{
  width:100%;
}
.search-close-icon {
  display: block !important;
  right: 0px;
}

.expand-enter-active {
  animation: expand 0.2s ease-in-out forwards;
}

.expand-leave-active {
  animation: contract 0.2s ease-in-out forwards;
}

.loader-container-small {
  padding: 1px 5px 0px 0px;
}

.loader-small {
  float: left;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #d26d13;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 0.5s linear infinite;
}

.name-heading {
  background-color: #f1f2f4;
}
.contacts-ec-cta{
  float:right;
}
.contacts-ec-cta button.buttonstyle{
  padding:6px 0.6em 6px 0.6em;
  font-size:13px;
  bottom:0!important;
}
.table-mobile tr {
  border-bottom: 1px solid #ccc;
}

.tableContent table td,
.tableContent table th {
  padding: 3px;
  vertical-align: top;
}

.table-mobile tr td {
  display: block;
  padding: 7px;
  border: 1px solid rgba(221, 221, 221, 0.6);
}

.table-mobile table tr td:nth-of-type(1) {
  font-weight: bold;
  font-size: 14px;
}

.table-mobile tr td a {
  max-width: calc(100vw - 100px);
  font-size: 18px;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-mobile tr td span {
  float: left;
  margin-right: 50px;
  min-width: 76px;
  line-height: 20px;
}

select,
input,
button {
  font-size: 13px;
}
.table-mobile tr td.no-phone{
  overflow:hidden;
}

#table-mobile.table-mobile tr td select {
  width: auto;
}

.table-mobile tr td a {
  text-transform: capitalize;
}

.table-mobile tr td a.buttonstyle {
  float: right;
  background: #d26d13;
  color: #fff;
  padding: 6px 0.6em 6px 0.6em;
  min-width: 40px;
  text-align: center;
  font-size: 13px;
  position: relative;
  bottom: 1px;
  margin-left: 7px;
  cursor: pointer;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
}

.buttonstyle.disabled {
  background-color: grey !important;
}

.no-phone {
  display: flex;
}

.img-star {
  max-width: 22px;
  vertical-align: middle;
}

.img-plus {
  max-width: 13px;
  margin-left: 10px;
  vertical-align: middle;
}

.patient-name {
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  padding-top: 1px;
}

.phone-dropdown-design {
  margin-right: 0px;
  margin-left: 29px;
}

.content-no-mail {
  font-style: italic;
  font-size: 13px;
  margin: 2px 0px 8px 0px;
  word-wrap: break-word;
}

/* Stage 1: Before entering */
.fade-full-enter {
  opacity: 0;
}

/* stage 2. Entered */
.fade-full-enter-active {
  transition: opacity 0.1s ease-in-out;
}

/* stage 3. leave */
.fade-full-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
}
.no-phone-client-div {
  padding-left: 29px;
  position: relative;
}
#table-mobile.table-mobile tr {
  border-bottom: none !important;
}
td.name-heading {
  padding: 10px !important;
  border-bottom: none !important;
  background: #f0f0f0;
}
td.ind-group-block {
  padding: 0 !important;
  background: #fff;
  border-bottom: none !important;
  padding: 0 !important;
  border-right: 1px solid #eeeeee !important;
  overflow: hidden;
  max-width: 100%;
}
.btn-group-chat {
  background: #79797b !important;
  font-size: 13px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  font-weight: normal;
  line-height: 15px;
  bottom:0!important;
}
.btn-group-chat:hover {
  background: #d26d13 !important;
}
.individual-group-con {
  padding: 10px 12px;
  border-top: 1px solid #ced2d9;
}
.ind-member-info {
  border-bottom: 1px solid #eeeeee;
  clear: both !important;
  padding: 10px 0;
  overflow: hidden;
}
.ind-member-info:last-child {
  border-bottom: none;
}
.ind-group-name {
  margin: 10px auto;
}
.ind-lhs-info {
  float: left;
  width: 60%;
}
.ind-lhs-info .phone-dropdown-design {
  margin-left: 0;
}
.ind-lhs-info ul {
  margin: 0 0 5px 0;
  padding: 0;
  list-style: none;
}
.ind-lhs-info ul li {
  margin-right: 5px;
}
.ind-lhs-info ul li a {
  color: #d26d13;
  font-weight: bold;
  font-size: 14px !important;
}
.ind-rhs-info {
  float: right;
  text-align: right;
  position: relative;
  top: 15px;
}
.ind-clear {
  clear: both;
}
.text-disabled {
  color: gray;
}
.alertbox {
  max-width: 27%;
  font-style: italic;
  font-size: small;
}
.grey--text {
  color: #79797b;
}

@media (max-width: 768px) {
  .table-mobile tr td span {
    margin-right: 0;
    min-width: 60px;
  }
  .alertbox {
    max-width: 55%;
    font-size: small;
  }
  .contacts-ec-cta{
    display: block;
    float:none;
    overflow: hidden;
    margin-top:5px;
  }
}

@media (max-width: 414px) {
  .table-mobile tr td span {
    min-width: 45px;
    font-size: 12px;
  }
  .table-mobile tr td a {
    max-width: calc(100vw - 189px);
    font-size: 16px;
  }
  .table-mobile tr td a.buttonstyle,
  .buttonstyle {
    padding: 6px 0.3em 6px 0.3em;
    font-size: 12px;
    line-height: 14px;
    margin-top: 3px;
  }
  .content-no-mail {
    font-size: 12px;
  }
  .alertbox {
    max-width: 52%;
    font-size: x-small;
  }
  .contacts-ec-cta button.buttonstyle, .contacts-ec-cta .buttonstyle.btn-group-chat{
  padding:6px 0.6em 6px 0.6em!important;
}

 }
@media (max-width: 320px) {
  #secondaryContentContainer .filter-selected {
    min-width: 54px;
  }

  .ind-lhs-info {
    width: 149px;
  }
  .ind-rhs-info {
    top: 22px;
  }
  .phone-dropdown-design {
    margin-left: 5px;
  }
  .individual-group-con {
    padding: 10px 6px 10px 8px;
  }
  .ind-rhs-info {
    right: 4px;
  }
    .contacts-ec-cta button.buttonstyle, .contacts-ec-cta .buttonstyle.btn-group-chat{
  padding:6px 0.6em 6px 0.6em!important;
}
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes expand {
  from {
    opacity: 0;
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

@keyframes contract {
  from {
    opacity: 1;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform: scaleY(0);
  }
}
</style>
